export const largeStarSize = 35;
export const smallStarSize = 15;
export const ratingCountThreshold = 4;
export const starNumbers = [1, 2, 3, 4, 5];
export const userStopColor = 'rgba(132, 180, 235, 0.45)';
export const defaultStopColor = '#CCCCCC';
